<template>
    <ckeditor
        ref="txtArea"
        @input="handleInput"
        @change="handleInput"
        :value="value"
        style="border: 1px solid #000"
        :label="lbl"
        :outline="outline"
    />
</template>
<script>
export default {
  props: {
    label: String,
    value: String,
    outline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      content: this.value,
      lbl: this.label
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e)
    }
  }
}
</script>